<header class="header-1" *transloco="let t; prefix: 'header'">
  <div class="branding">
    <a href="/dashboard/pps" class="nav-link">
      <!--<cds-icon shape="vm-bug"></clr-icon>-->
      <img class="pps_logo" [src]="branding.logoNavbar" [alt]="branding.appTitle + '-Logo'" />
      <span class="title">{{ branding.appTitle }}</span><span class="ppsversion">V {{ ppsversion }}</span>
      <span *ngIf="devMode" class="title">&nbsp;&nbsp;  {{ stage }}</span>
    </a>
  </div>

  <form class="search">
    <label for="search_input">
      <clr-dropdown class="left-top" [clrCloseMenuOnItemClick]="true">
        <input clrDropdownTrigger class="clr-input"
               aria-label="Suche Seriennr./Charge in Jobs und Lager"
               id="search_input"
               type="text"
               placeholder="{{ t('search') }}"
               (keyup)="onKeyUp($event)">
        <clr-dropdown-menu *clrIfOpen>
          <label class="dropdown-header" aria-hidden="true">Jobs im PPS</label>
          <a *ngFor="let jobs of foundJobs" clrDropdownItem (click)="goToJob(jobs.project_id, jobs.job_id)">{{ jobs.project_id }} - {{ jobs.name }}</a>
          <label *ngIf="foundJobs.length === 0" class="dropdown-item disabled" aria-hidden="true">keine Treffer</label>
          <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
          <label class="dropdown-header" aria-hidden="true">Lager (Seriennr. / Charge)</label>
          <a *ngFor="let hit of foundSerials" clrDropdownItem (click)="goToWarehouse(hit)">
            {{ hit.serial_nr || hit.heat_nr }}<ng-container *ngIf="hit.technical_drawing"> · {{ hit.technical_drawing }}</ng-container> · <span [class.stock-on]="hit.on_stock" [class.stock-off]="!hit.on_stock">{{ hit.on_stock ? hit.number_of_pieces + ' auf Lager' : 'abgegangen' }}</span>
          </a>
          <label *ngIf="foundSerials.length === 0" class="dropdown-item disabled" aria-hidden="true">keine Treffer</label>
        </clr-dropdown-menu>
      </clr-dropdown>
    </label>
  </form>

  <!--<div class="header-actions">
    <app-language-selector></app-language-selector>
  </div>-->

  <div class="settings">
    <app-language-selector></app-language-selector>
    <app-theme-toggle></app-theme-toggle>
    <a (click)=logoutUser() class="nav-link nav-icon-text">
      <cds-icon shape="user"></cds-icon>
      <span class="nav-text">{{ firstName }} {{ surName }}</span>
    </a>
    <clr-dropdown class="bottom-left" [clrCloseMenuOnItemClick]="true">
      <button class="nav-icon dropdown-toggle" clrDropdownTrigger aria-label="Toggle Settings Menu">
        <cds-icon shape="cog"></cds-icon>
        <cds-icon shape="angle" direction="down"></cds-icon>
      </button>
      <div class="dropdown-menu" *clrIfOpen>
        <a routerLink="/impressum" class="dropdown-item">  {{ t('aboutUs') }}</a>
        <a routerLink="/settings" class="dropdown-item">  {{ t('setup') }}</a>
        <a (click)=logoutUser()  class="dropdown-item">  {{ t('logout') }}</a>
      </div>
    </clr-dropdown>
  </div>
</header>
